import {
  TOGGLE_CART_PACKAGES,
  TOGGLE_CART_SIDEBAR,
  TOGGLE_CART_PACKAGE_NIGHTS,
  MODAL_OPEN,
  BOOKING_DATE_WARNING_MODAL_OPEN,
  ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN,
  BEDBANK_PRICE_CHANGE_MODAL_OPEN,
  JOURNEY_SOLD_OUT_MODAL_OPEN,
  CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN,
  JOURNEY_COST_CHANGE_MODAL_OPEN,
  FLIGHTS_SESSION_EXPIRED_MODAL_OPEN,
  TRAVELLER_NAME_TOO_LONG_MODAL_OPEN,
  GENERIC_ORDER_ERROR_MODAL_OPEN,
  AUTH_MODAL_OPEN,
  QUOTE_EMAIL_MODAL_OPEN,
  MODAL_CLOSE,
  ACCOUNT_ACCESS_SHOW_LOGIN,
  ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD,
  ACCOUNT_ACCESS_SHOW_RESET_PASSWORD,
  ACCOUNT_ACCESS_SUCCESS,
  ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK,
  SHOW_LATITUDE_PAYMENT_MODAL,
  SHOW_LATITUDE_PAY_PAYMENT_MODAL,
  SHOW_LATITUDE_GEM_PAYMENT_MODAL,
  SHOW_BRIDGER_PAY_PAYMENT_MODAL,
  ADD_PAYMENT_PROVIDER,
  SHOW_USE_GIFT_CARD_MODAL,
  SHOW_CHANGE_DATE_WARNING_MODAL,
  SHOW_CHANGE_DATE_ADDON_WARNING_MODAL,
  SHOW_LATITUDE_PAYMENT_FAILED_MODAL,
  SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL,
  SHOW_ACCOUNT_TAKE_OVER_MODAL,
  SHOW_CUSTOMER_SIGNATURE_MODAL,
  ACCOUNT_DROPDOWN_TOGGLE,
  ACCOUNT_DROPDOWN_TOGGLE_STANDALONE,
  REGION_DROPDOWN_TOGGLE,
  EVENTS_DROPDOWN_TOGGLE,
  PHONE_DROPDOWN_TOGGLE,
  CLOSE_SOCIAL_WIDGET,
  API_CALL,
  TOUR_V2_PRICE_CHANGE_MODAL_OPEN,
  JOURNEY_PRICE_CHANGE_MODAL_OPEN,
  SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL,
  HOTEL_PRICE_CHANGE_MODAL_OPEN,
  BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN,
  BUNDLE_PRICE_CHANGE_MODAL_OPEN,
  SHOW_CHECKOUT_CART_MODE_MODAL,
} from './actionConstants'
import { USER_LOGIN } from './apiActionConstants'
import { webViewAccountAccess } from 'api/auth'
import * as Analytics from 'analytics/analytics'
import { cartEvent } from 'analytics/snowplow/events'

export function modalOpen(heading, message) {
  return {
    type: MODAL_OPEN,
    data: {
      heading,
      message,
    },
  }
}

export function bookingDateWarningModalOpen() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'bookingDateWarning' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: BOOKING_DATE_WARNING_MODAL_OPEN,
  }
}

/**
 * @deprecated
 * Used by the old checkout
 *
 * @remarks
 * replaced with { @link | hotelPriceChangeModalOpen }
 */
export function accommodationPriceChangeModalOpen(cartItemId: string, price: number, surcharge?: number, extraGuestSurcharge?: number) {
  return {
    type: ACCOMMODATION_PRICE_CHANGE_MODAL_OPEN,
    data: {
      cartItemId,
      price,
      surcharge,
      extraGuestSurcharge,
    },
  }
}

/**
 * @deprecated
 * Used by the old checkout
 *
 * @remarks
 * replaced with { @link | bedbankHotelPriceChangeModalOpen }
 */
export function bedbankPriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'bedbankPriceChanged' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: BEDBANK_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function hotelPriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  return {
    type: HOTEL_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function bundlePriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  return {
    type: BUNDLE_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function bedbankHotelPriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  return {
    type: BEDBANK_HOTEL_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function tourV2PriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'tourV2PriceChanged' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: TOUR_V2_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function journeyPriceChangeModalOpen(priceChange: App.UiPriceChangeModalState) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'journeyPriceChanged' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: JOURNEY_PRICE_CHANGE_MODAL_OPEN,
    data: {
      priceChange,
    },
  }
}

export function journeySoldOutModalOpen() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'journeySoldOut' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: JOURNEY_SOLD_OUT_MODAL_OPEN,
  }
}

export function cantProcessOrderOnlineModalOpen(refCode: string) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'cantProcessOnlineOrder' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: CANT_PROCESS_ORDER_ONLINE_MODAL_OPEN,
    data: {
      refCode,
    },
  }
}

/**
 * @deprecated - Used by the old checkout
 */
export function journeyCostChangeModalOpen(message: string, cost: App.UiModalCost) {
  return {
    type: JOURNEY_COST_CHANGE_MODAL_OPEN,
    data: {
      message,
      cost,
    },
  }
}

export function flightsSessionExpiredModalOpen() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'flightsSessionExpired' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: FLIGHTS_SESSION_EXPIRED_MODAL_OPEN,
  }
}

export function travellerNameTooLongModalOpen() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'travellerNameTooLong' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: TRAVELLER_NAME_TOO_LONG_MODAL_OPEN,
  }
}

export function genericOrderErrorModalOpen(errors) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'generic' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: GENERIC_ORDER_ERROR_MODAL_OPEN,
    data: {
      errors,
    },
  }
}

export function authModalOpen(heading?: string, message?: string) {
  return {
    type: AUTH_MODAL_OPEN,
    data: {
      heading,
      message,
    },
  }
}

export function quoteEmailModalOpen() {
  return {
    type: QUOTE_EMAIL_MODAL_OPEN,
  }
}

export function modalClose() {
  return {
    type: MODAL_CLOSE,
  }
}

const useAppAuth = (state: App.State) => state.config.headlessMode && (window?.webkit?.messageHandlers?.authenticateUser || window?.appInterface)

export function accountAccessShowLogin(mode?: App.UiAccountModalMode) {
  return (dispatch, getState) => {
    if (useAppAuth(getState())) {
      dispatch({
        type: API_CALL,
        api: USER_LOGIN,
        request: () => webViewAccountAccess().catch((error) => {
          // login failed/closed it, close the auth modal
          dispatch({
            type: MODAL_CLOSE,
          })
          throw error
        }),
      })
    }

    // even if we're in an app environment still open the auth modal
    // there is code out there that waits for the modal itself to close to know login failed
    // e.g. the AuthRoute component
    dispatch({
      type: ACCOUNT_ACCESS_SHOW_LOGIN,
      mode,
    })
  }
}

export function accountAccessShowResetPassword() {
  return {
    type: ACCOUNT_ACCESS_SHOW_RESET_PASSWORD,
  }
}

export function accountAccessShowForgotPassword() {
  return {
    type: ACCOUNT_ACCESS_SHOW_FORGOT_PASSWORD,
  }
}

export function accountAccessSuccess(text) {
  return {
    type: ACCOUNT_ACCESS_SUCCESS,
    data: {
      heading: text.heading,
      message: text.message,
    },
  }
}

export function accountAccessShowPartnershipLink() {
  return {
    type: ACCOUNT_ACCESS_SHOW_PARTNERSHIP_LINK,
  }
}

export function showLatitudePaymentModal() {
  return {
    type: SHOW_LATITUDE_PAYMENT_MODAL,
  }
}

export function showLatitudePayPaymentModal(url: string) {
  return {
    type: SHOW_LATITUDE_PAY_PAYMENT_MODAL,
    url,
  }
}

export function showBridgerPayPaymentModal() {
  return {
    type: SHOW_BRIDGER_PAY_PAYMENT_MODAL,
  }
}

export function addPaymentProvider(paymentProvider: string) {
  return {
    type: ADD_PAYMENT_PROVIDER,
    paymentProvider,
  }
}

export function showLatitudeGemPaymentModal(url: string) {
  return {
    type: SHOW_LATITUDE_GEM_PAYMENT_MODAL,
    url,
  }
}

export function showUseGiftCardModal() {
  return {
    type: SHOW_USE_GIFT_CARD_MODAL,
  }
}

export function showChangeDateWarningModal() {
  return {
    type: SHOW_CHANGE_DATE_WARNING_MODAL,
  }
}

export function showChangeDateAddonWarningModal() {
  return {
    type: SHOW_CHANGE_DATE_ADDON_WARNING_MODAL,
  }
}

export function showLatitudePaymentFailedModal() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'latitudeFailed' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: SHOW_LATITUDE_PAYMENT_FAILED_MODAL,
  }
}

export function showBridgerPayPaymentFailedModal(paymentProvider) {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'bridgerFailed' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: SHOW_BRIDGERPAY_PAYMENT_FAILED_MODAL,
    data: {
      paymentProvider,
    },
  }
}

export function showAccountTakeOverModal() {
  const event = cartEvent('TRANSACTION_FAILED', { errorReason: 'accountTakeover' })
  if (event) Analytics.track('cart-event', event)
  return {
    type: SHOW_ACCOUNT_TAKE_OVER_MODAL,
  }
}

export function showFlightRebookingConditionsModal() {
  return {
    type: SHOW_FLIGHT_REBOOKING_CONDITIONS_MODAL,
  }
}

export function showCustomerSignatureModal(showConfirmationOptions = false) {
  return {
    type: SHOW_CUSTOMER_SIGNATURE_MODAL,
    showConfirmationOptions,
  }
}

export function showCheckoutCartModeModal() {
  return {
    type: SHOW_CHECKOUT_CART_MODE_MODAL,
  }
}

export function toggleAccountDropdown() {
  return {
    type: ACCOUNT_DROPDOWN_TOGGLE,
  }
}

export function toggleAccountDropdownStandAlone() {
  return {
    type: ACCOUNT_DROPDOWN_TOGGLE_STANDALONE,
  }
}

export function toggleRegionDropdown() {
  return {
    type: REGION_DROPDOWN_TOGGLE,
  }
}

export function toggleEventsDropdown() {
  return {
    type: EVENTS_DROPDOWN_TOGGLE,
  }
}

export function togglePhoneDropdown() {
  return {
    type: PHONE_DROPDOWN_TOGGLE,
  }
}

export function toggleCartPackages(open: boolean) {
  return {
    type: TOGGLE_CART_PACKAGES,
    open,
  }
}

export function toggleCartPackageNights(open: boolean) {
  return {
    type: TOGGLE_CART_PACKAGE_NIGHTS,
    open,
  }
}

export function toggleCartSidebar(open: boolean) {
  return {
    type: TOGGLE_CART_SIDEBAR,
    open,
  }
}

export function closeSocialWidget() {
  return {
    type: CLOSE_SOCIAL_WIDGET,
  }
}
